<template>
  <div class="event-days-table table-overflow-hide">
    <div class="directoryTable scrollable-55vh" style="max-height: 55vh; height: auto">
      <table class="table">
        <thead class="sticky-header">
          <tr>
            <th class="small-col"></th>
            <th>Date</th>
            <th>From</th>
            <th>To</th>
            <th>Interval</th>
            <th class="small-col"><span class="d-none d-lg-block">Reminder</span></th>
            <th class="small-col"></th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="day in sort(event?.conference_days || [], (i) => i.start)"
            :key="day.conference_days_id"
          >
            <td>
              <v-btn
                color="normal"
                icon
                style="max-width: 30px; max-height: 30px"
                @click="
                  state.showDayOptions = true;
                  state.optionsDay = day;
                "
                data-cy="event-day-options-modal-btn"
              >
                <v-tooltip activator="parent" location="bottom">Advanced Options</v-tooltip>

                <v-icon>mdi-cog</v-icon>
              </v-btn>
            </td>
            <td>
              <date-picker
                :model-value="new Date(day.start)"
                @update:model-value="day.start = dayjs($event).format(`YYYY-MM-DD HH:mm:ss`)"
                class="custom-input date"
                density="compact"
                type="date"
              ></date-picker>
            </td>
            <td>
              <date-picker
                :model-value="new Date(day.start)"
                @update:model-value="day.start = dayjs($event).format(`YYYY-MM-DD HH:mm:ss`)"
                class="custom-input date"
                density="compact"
                type="time"
              ></date-picker>
            </td>
            <td>
              <date-picker
                :model-value="new Date(day.end)"
                @update:model-value="day.end = dayjs($event).format(`YYYY-MM-DD HH:mm:ss`)"
                class="custom-input date"
                density="compact"
                type="time"
              ></date-picker>
            </td>
            <td>
              <v-text-field
                class="custom-input number"
                density="compact"
                type="number"
                :model-value="day.time_interval"
                @update:model-value="
                  if ((+$event || +$event === 0) && +$event > 0) day.time_interval = +$event;
                "
              ></v-text-field>
            </td>
            <td>
              <div class="d-flex gap-2 align-center justify-content-center" style="width: 100%">
                <v-btn
                  @click="
                    state.showParentReminder = true;
                    state.parenReminderDay = day;
                  "
                  color="normal"
                  icon
                  style="max-width: 30px; max-height: 30px"
                  class="icon-btn-relative"
                >
                  <v-tooltip location="bottom" activator="parent">Reminder Email</v-tooltip>
                  <v-icon>mdi-email-outline</v-icon>
                  <v-icon class="icon-absolute" size="x-small">mdi-bell-outline</v-icon>
                </v-btn>
              </div>
            </td>
            <td>
              <v-btn
                @click="openDialog(day)"
                color="normal"
                icon
                style="max-width: 30px; max-height: 30px"
                :loading="state.loadingDelete.includes(day.conference_days_id)"
              >
                <v-tooltip activator="parent" location="bottom">Delete this day</v-tooltip>
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
    <v-dialog v-model="dialogVisible"  persistent max-width="450">
      <v-card>
        <v-card-title>Confirm Delete</v-card-title>
        <v-card-text>
        Are you sure you want to delete this conference day?
        {{ dayjs(state.optionsDay?.start).format('LLL') }} - {{ dayjs(state.optionsDay?.end).format('LT') }}
        </v-card-text>
        <v-card-actions class="space-between">
          <v-btn color="primary" text @click="deleteDay(state.optionsDay?.conference_days_id,false)">Delete</v-btn>
          <v-btn color="primary" text @click="closeDialog(state.optionsDay?.conference_days_id)">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmVisible"  persistent max-width="450">
      <v-card>
        <v-card-title>Confirm Delete</v-card-title>
        <v-card-text>
        {{ dialogConfirmMessage }}
        </v-card-text>

        <v-card-actions class="space-between">
          <v-btn color="primary" text @click="deleteDay(state.optionsDay?.conference_days_id,true)">Delete</v-btn>
          <v-btn color="primary" text @click="closeDialog(state.optionsDay?.conference_days_id)">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <parent-reminder-modal
    v-if="state.parenReminderDay"
    v-model:show="state.showParentReminder"
    :event-day="state.parenReminderDay!"
    @update:event-day="Object.assign(state.parenReminderDay!, $event)"
  ></parent-reminder-modal>
  <event-day-options-modal
    v-if="state.optionsDay"
    v-model:show="state.showDayOptions"
    :event-day="state.optionsDay!"
    @update:event-day="Object.assign(state.optionsDay!, $event)"
  ></event-day-options-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { useConferenceStore } from "@/stores/teacher/conference";
import { computed } from "vue";
import DatePicker from "@/components/datePicker.vue";
import type { ConferenceDay } from "@/api_types/teacher";
import { reactive } from "vue";
import ParentReminderModal from "./ParentReminderModal.vue";
import EventDayOptionsModal from "./eventDayOptionsModal.vue";
import dayjs from "dayjs";
import FetchService from "@/services/fetch.service";
import { sort } from "@/utils/sort";
import { useAlertsStore } from '@/stores/alerts';

const props = defineProps<{ eventId: string }>();

const state = reactive({
  showParentReminder: false,
  parenReminderDay: null as null | ConferenceDay,
  showDayOptions: false,
  optionsDay: null as null | ConferenceDay,
  loadingDelete: [] as string[]
});

const confStore = useConferenceStore();

const event = computed(() => confStore.selected!);
const deleteDay = async (day_id:string, confirmed:boolean = false) => {
  state.loadingDelete.push(day_id);
  const res = await FetchService.fetchData(`/conference-days/${day_id}?confirmed=${confirmed}`, "delete");

  if (res.status === true) {
    const days = event.value.conference_days.filter((d) => d.conference_days_id !== day_id);
    confStore.updatedConference(props.eventId, {
      conference_days: days
    });

    Object.assign(event.value, {
      conference_days: days
    });
    useAlertsStore().addAlert("success",'Deleted Event Day');
    state.loadingDelete = state.loadingDelete.filter((str) => str !== day_id);
    state.optionsDay = null;
    dialogVisible.value = false;
    dialogConfirmVisible.value=false;
  }else if (res.confirm === true){
    console.log(res);
      dialogVisible.value = false;
      dialogConfirmMessage.value = res.message;
      dialogConfirmVisible.value=true;
      console.log(res.message);
  }else{
    useAlertsStore().addAlert("error",res.message);
    state.loadingDelete = state.loadingDelete.filter((str) => str !== day_id);
    state.optionsDay = null;
    dialogVisible.value = false;
    dialogConfirmVisible.value=false;
  }
};

const dialogVisible = ref(false);
const dialogConfirmVisible = ref(false);
const dialogConfirmMessage = ref("");

function openDialog(day) {
  state.optionsDay = day;
  dialogVisible.value = true;
}

function closeDialog(day_id) {
  state.optionsDay = null;
  dialogVisible.value = false;
  dialogConfirmVisible.value = false;
  dialogConfirmMessage.value = "";
  state.loadingDelete = state.loadingDelete.filter((str) => str !== day_id);
}

</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.small-col {
  width: 10px;
}

.custom-input.number {
  width: 70px;
}
.custom-input.date {
  min-width: 130px;
}

.table {
  td:not(:last-child),
  th:not(:last-child) {
    padding-right: 0 !important;
  }
}

.icon-btn-relative {
  position: relative;
  .icon-absolute {
    position: absolute;
    bottom: 5%;
    right: -1%;
    background-color: white;
    padding-top: 2px;
    border-radius: 10px;
    overflow: hidden;
  }
}
.space-between {
  display: flex;
  justify-content: space-between;
}
</style>
